import { render, staticRenderFns } from "./Daycounter.vue?vue&type=template&id=2ea6a532&scoped=true&"
import script from "./Daycounter.vue?vue&type=script&lang=js&"
export * from "./Daycounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea6a532",
  null
  
)

export default component.exports